import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative w-full overflow-hidden rounded-lg border bg-white text-left" }
const _hoisted_2 = { class: "flex flex-col gap-3 px-4 py-3 md:grid md:grid-cols-12 md:items-center md:gap-6 md:px-6 md:py-4" }
const _hoisted_3 = { class: "md:col-span-3 text-sm text-textPrimary" }
const _hoisted_4 = { class: "leading-snug" }
const _hoisted_5 = { class: "leading-snug" }
const _hoisted_6 = { class: "md:col-span-6 text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-around" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-md font-bold text-textPrimary" }, "Passou"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-md font-bold text-textPrimary" }, "Assumiu")
], -1)
const _hoisted_8 = { class: "flex items-stretch justify-center gap-2 rounded-md bg-gray-200 px-3 py-2 md:items-center md:px-6 md:py-1 text-center" }
const _hoisted_9 = { class: "flex flex-col items-start justify-center md:flex-row md:items-center md:gap-2 min-w-0 flex-1" }
const _hoisted_10 = { class: "text-sm font-medium text-left md:truncate md:max-w-[150px]" }
const _hoisted_11 = { class: "text-xs font-bold text-textPrimary whitespace-nowrap" }
const _hoisted_12 = { class: "flex flex-col items-start justify-center md:flex-row md:items-center md:gap-2 min-w-0 flex-1" }
const _hoisted_13 = { class: "text-sm font-medium text-left md:truncate md:max-w-[150px]" }
const _hoisted_14 = { class: "text-xs font-bold text-textPrimary whitespace-nowrap" }
const _hoisted_15 = { class: "md:col-span-2 text-sm text-textPrimary" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-gray-800" }, "Escala", -1)
const _hoisted_17 = { class: "leading-snug text-textPrimary" }
const _hoisted_18 = { class: "leading-snug text-xs text-textPrimary" }
const _hoisted_19 = { class: "absolute top-3 right-3 md:static md:col-span-1 md:flex md:justify-end" }
const _hoisted_20 = {
  key: 0,
  class: "flex flex-col gap-3 md:flex-row md:justify-between border-t bg-gray-200 px-4 py-3 md:px-6 md:py-4 text-sm"
}
const _hoisted_21 = { class: "text-textPrimary" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", { class: "text-textPrimary" }, "ID da troca:", -1)
const _hoisted_23 = { class: "text-textPrimary" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("strong", { class: "text-textPrimary" }, "Data e hora da troca:", -1)
const _hoisted_25 = { class: "text-textPrimary" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("strong", { class: "text-textPrimary" }, "Empresa:", -1)
const _hoisted_27 = { class: "text-textPrimary" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", { class: "text-textPrimary" }, "Posição:", -1)
const _hoisted_29 = { class: "flex gap-2 md:gap-4" }

import { ref, computed } from 'vue'
import { mdiArrowRightThin, mdiChevronDown, mdiChevronUp } from '@mdi/js'
import OutlineButton from '../../../components/designSystem/Buttons/OutlineButton/index.vue'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import type { HandoverInviteResponse } from '@/Network/Types/Responses/HandoverInviteResponses'
import { translateTimezone } from '@/utils/timeConverter'


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryShiftCard',
  props: {
    historyItem: {}
  },
  emits: ['view-shift', 'view-terms'],
  setup(__props: any, { emit }) {

const props = __props;





const isExpanded = ref(false)

const startDate = computed(() => formatDate(props.historyItem.doctorStation?.startHour))
const startTime = computed(() => formatTime(props.historyItem.doctorStation?.startHour))
const endDate = computed(() => formatDate(props.historyItem.doctorStation?.endHour))
const endTime = computed(() => formatTime(props.historyItem.doctorStation?.endHour))

const personWhoPassedName = computed(() => props.historyItem.doctorOrigin?.mainCrm?.name ?? 'N/D')
const personWhoPassedId = computed(() => {
  const number = props.historyItem.doctorOrigin?.mainCrm?.number ?? ''
  const uf = props.historyItem.doctorOrigin?.mainCrm?.uf ?? ''
  if (number && uf) return `${number}-${uf}`
  return `${number}${uf}`.trim()
})

const personWhoAssumedName = computed(() => props.historyItem.doctorDestiny?.mainCrm?.name ?? 'N/D')
const personWhoAssumedId = computed(() => {
  const number = props.historyItem.doctorDestiny?.mainCrm?.number ?? ''
  const uf = props.historyItem.doctorDestiny?.mainCrm?.uf ?? ''
  if (number && uf) return `${number}-${uf}`
  return `${number}${uf}`.trim()
})

const scaleName = computed(() => props.historyItem.doctorStation?.station?.schedule?.name ?? 'N/D')
const location = computed(
  () => props.historyItem.doctorStation?.station?.schedule?.healthUnit?.name ?? 'N/D'
)

const tradeDateTime = computed(() => formatDateTime(props.historyItem.updatedAt))
const companyName = computed(
  () => props.historyItem.doctorStation?.station?.schedule?.healthUnit?.company?.name ?? 'N/D'
)
const positionName = computed(
  () => props.historyItem.doctorStation?.station?.position?.name ?? 'N/D'
)

const toggleExpansion = () => {
  isExpanded.value = !isExpanded.value
}

function onViewShiftClick() {
  emit('view-shift', props.historyItem.id)
}

function onViewTerms() {
  emit('view-terms')
}

function formatDate(dateString?: string | null) {
  if (!dateString) return 'N/D'
  return format(parseISO(dateString), 'dd/MM/yyyy', { locale: ptBR })
}

function formatTime(dateString?: string | null) {
  if (!dateString) return '--:--'
  return format(parseISO(dateString), 'HH:mm', { locale: ptBR })
}

function formatDateTime(dateString?: string | null) {
  if (!dateString) return 'N/D'
  return (
    format(parseISO(dateString), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR }) +
    ' (' +
    translateTimezone(Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone) +
    ')'
  )
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(" De "),
          _createElementVNode("strong", null, _toDisplayString(startDate.value), 1),
          _createTextVNode(" às " + _toDisplayString(startTime.value), 1)
        ]),
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(" Até "),
          _createElementVNode("strong", null, _toDisplayString(endDate.value), 1),
          _createTextVNode(" às " + _toDisplayString(endTime.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(personWhoPassedName.value), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(personWhoPassedId.value), 1)
          ]),
          _createVNode(_component_v_icon, {
            color: "text-textPrimary",
            class: "flex-shrink-0 self-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(mdiArrowRightThin)), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(personWhoAssumedName.value), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(personWhoAssumedId.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("p", _hoisted_17, _toDisplayString(scaleName.value), 1),
        _createElementVNode("p", _hoisted_18, _toDisplayString(location.value), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_v_icon, {
          class: "cursor-pointer",
          color: "text-textPrimary",
          onClick: toggleExpansion
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(isExpanded.value ? _unref(mdiChevronUp) : _unref(mdiChevronDown)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (isExpanded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(" #" + _toDisplayString(_ctx.historyItem.id), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createTextVNode(" " + _toDisplayString(tradeDateTime.value), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(companyName.value), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createTextVNode(" " + _toDisplayString(positionName.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(OutlineButton, {
              text: "Ver termos",
              onClick: onViewTerms,
              height: "32px",
              class: "flex-1 md:flex-none bg-white"
            }),
            _createVNode(OutlineButton, {
              text: "Ver plantão",
              onClick: onViewShiftClick,
              height: "32px",
              class: "flex-1 md:flex-none bg-white"
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})